import { http } from '@/shared/api/httpClient';
import type {
  AdminClub,
  ClubProfile,
  ClubWithFacilities,
  CreateClubRequest,
  MyClub,
  UpdateClubRequest,
} from '../model/types';

/** Wywolania endpointow `/api/clubs/**`. */

/**
 * Pobiera kluby zalogowanego uzytkownika wraz z jego rola w kazdym z nich.
 *
 * Swiadomie nie owijamy tu `GET /api/clubs` — ten zwraca wszystkie kluby
 * w systemie i nie nadaje sie do wyboru kontekstu pracy.
 */
export function getMyClubs(): Promise<MyClub[]> {
  return http.get<MyClub[]>('/clubs/my');
}

/** Pobiera wizytowke pojedynczego klubu — np. obiekt, na ktorym gra sie mecz. */
export function getClub(clubId: string): Promise<ClubProfile> {
  return http.get<ClubProfile>(`/clubs/${clubId}`);
}

/**
 * Pobiera wszystkie kluby wraz z ich obiektami — na potrzeby przegladania
 * infrastruktury.
 *
 * To jedyne uzasadnione uzycie `GET /api/clubs`: organizator szuka kortu, na
 * ktorym rozlozy mecze, i wolno mu siegnac takze poza wlasny klub. Do wyboru
 * kontekstu pracy sluzy `getMyClubs`.
 */
export function getClubsWithFacilities(): Promise<ClubWithFacilities[]> {
  return http.get<ClubWithFacilities[]>('/clubs');
}

/**
 * Dodaje uzytkownika do klubu z podana rola (systemowa: OWNER, MANAGER,
 * TRAINER, WORKER — albo wlasna klubu). Wymaga uprawnienia MANAGE_MEMBERS
 * w klubie; ADMIN przechodzi bez czlonkostwa.
 */
export function addClubMember(clubId: string, userId: string, role: string): Promise<void> {
  return http.post<void>(`/clubs/${clubId}/members`, { userId, role });
}

/** Pelna lista klubow dla panelu administratora (`GET /api/clubs`). */
export function getAdminClubs(): Promise<AdminClub[]> {
  return http.get<AdminClub[]>('/clubs');
}

/** Tworzy nowy klub (tylko ADMIN). */
export function createClub(request: CreateClubRequest): Promise<void> {
  return http.post<void>('/clubs', request);
}

/** Aktualizuje dane podstawowe klubu (tylko ADMIN). */
export function updateClub(clubId: string, request: UpdateClubRequest): Promise<void> {
  return http.put<void>(`/clubs/${clubId}`, request);
}

/** Trwale usuwa klub z obiektami, czlonkami i rolami (tylko ADMIN). */
export function deleteClub(clubId: string): Promise<void> {
  return http.delete<void>(`/clubs/${clubId}`);
}
